<template>
    <div class="admin-sidebar">
        <h4 class="sidebar-title">Admin</h4>

        <ul class="sidebar-menu">
            <li :class="{ active: $route.path === '/admin' }" @click="$router.push('/admin')">
                Dashboard
            </li>

            <li :class="{ active: $route.path.includes('/admin/places') }" @click="$router.push('/admin/places')">
                Places
            </li>

            <li :class="{ active: $route.path.includes('/admin/users') }" @click="$router.push('/admin/users')">
                Users
            </li>

            
            <li :class="{ active: $route.path.includes('/admin/connections') }" @click="$router.push('/admin/connections')">
                Connections
            </li>

            <li :class="{ active: $route.path.includes('/admin/sessions') }" @click="$router.push('/admin/sessions')">
                Sessions
            </li>

            <li class="logout" @click="logout">
                Logout
            </li>
        </ul>
    </div>
</template>

<script>
import { signOut } from "firebase/auth";
import { auth } from "@/firebase";

export default {
    name: "AdminSidebar",

    methods: {
        async logout() {
            try {
                await signOut(auth);
                this.$router.push("/login");
            } catch (error) {
                console.error("Logout error:", error);
            }
        }
    }
};
</script>

<style lang="scss">
.admin-sidebar {
    width: 220px;
    height: 100vh;
    background: #13131d;
    color: white;
    padding: 20px;
    position: fixed;
    top: 0;
    left: 0;
    &::before {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-image: url(/img/noise.e7f2a273.gif);
        z-index: -1;
        background-color: rebeccapurple;
        opacity: 0.05;
    }
}

.sidebar-title {
    margin-bottom: 30px;
    font-size: 20px;
}

.sidebar-menu {
    list-style: none;
    padding-top: 30px;
}

.sidebar-menu li {
    padding: 12px;
    cursor: pointer;
    border-radius: 6px;
    margin-bottom: 10px;
    transition: 0.2s;
}

.sidebar-menu li:hover {
    background: #1f2937;
}

.sidebar-menu .active {
    background: #4f46e5;
}

.sidebar-menu .logout {
    margin-top: 30px;
    color: #ff4d4f;
}
</style>